import React from "react";
import { Row, Col } from "antd";
import Logo from "./images/logo.jpg";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Footer from "../components/Footer";

function AvisoLegalES({ t }) {
  return (
    <div className="politicas">
      <h1>{t("Aviso-legal.title")}</h1>
      <h2>{t("Aviso-legal.s1-title")}</h2>
      <br />
      <p>{t("Aviso-legal.s1-p1")}</p>
      <br />
      <p>{t("Aviso-legal.s1-p2")}</p>
      <br />
      <p>{t("Aviso-legal.s1-contact")}</p>
      <ul>
        <li>{t("Aviso-legal.s1-phone")}</li>
        <li>{t("Aviso-legal.s1-email-general")}</li>
        <li>{t("Aviso-legal.s1-email-support")}</li>
      </ul>
      <p>{t("Aviso-legal.s1-p3")}</p>
      <br />
      <h2>{t("Aviso-legal.s2-title")}</h2>
      <br />
      <h3>{t("Aviso-legal.s2-1-title")}</h3>
      <p>{t("Aviso-legal.s2-1-p1")}</p>
      <br />
      <p>{t("Aviso-legal.s2-1-p2")}</p>
      <br />
      <h3>{t("Aviso-legal.s2-2-title")}</h3>
      <p>{t("Aviso-legal.s2-2-p1")}</p>
      <br />
      <p>{t("Aviso-legal.s2-2-p2")}</p>
      <br />
      <h3>{t("Aviso-legal.s2-3-title")}</h3>
      <p>{t("Aviso-legal.s2-3-p1")}</p>
      <br />
      <p>{t("Aviso-legal.s2-3-p2")}</p>
      <br />
      <h3>{t("Aviso-legal.s2-4-title")}</h3>
      <p>{t("Aviso-legal.s2-4-p1")}</p>
      <br />
      <p>{t("Aviso-legal.s2-4-p2")}</p>
      <br />
      <p>{t("Aviso-legal.s2-4-p3")}</p>
      <br />
      <h3>{t("Aviso-legal.s2-5-title")}</h3>
      <p>{t("Aviso-legal.s2-5-p1")}</p>
      <br />
      <p>{t("Aviso-legal.s2-5-p2")}</p>
      <br />
      <p>{t("Aviso-legal.s2-5-p3")}</p>
      <p>{t("Aviso-legal.s2-5-a")}</p>
      <p>{t("Aviso-legal.s2-5-b")}</p>
      <p>{t("Aviso-legal.s2-5-c")}</p>
      <p>{t("Aviso-legal.s2-5-d")}</p>
      <p>{t("Aviso-legal.s2-5-e")}</p>
      <br />
      <h2>{t("Aviso-legal.s3-title")}</h2>
      <br />
      <p>{t("Aviso-legal.s3-p1")}</p>
      <br />
      <p>{t("Aviso-legal.s3-p2")}</p>
      <p>{t("Aviso-legal.s3-a")}</p>
      <p>{t("Aviso-legal.s3-b")}</p>
      <p>{t("Aviso-legal.s3-c")}</p>
      <p>{t("Aviso-legal.s3-d")}</p>
      <p>{t("Aviso-legal.s3-e")}</p>
      <br />
      <p>{t("Aviso-legal.s3-p3")}</p>
      <br />
      <h2>{t("Aviso-legal.s4-title")}</h2>
      <br />
      <p>{t("Aviso-legal.s4-p1")}</p>
      <br />
      <p>
        {t("Aviso-legal.s4-p2-before")}
        <Link to="/politica-cookies">{t("Aviso-legal.s4-link")}</Link>
        {t("Aviso-legal.s4-p2-after")}
      </p>
      <br />
      <h2>{t("Aviso-legal.s5-title")}</h2>
      <br />
      <p>{t("Aviso-legal.s5-p1")}</p>
      <br />
      <p>{t("Aviso-legal.s5-p2")}</p>
      <br />
      <p>{t("Aviso-legal.s5-p3")}</p>
      <br />
      <h2>{t("Aviso-legal.s6-title")}</h2>
      <br />
      <p>{t("Aviso-legal.s6-p1")}</p>
      <p>{t("Aviso-legal.s6-a")}</p>
      <p>{t("Aviso-legal.s6-b")}</p>
      <p>{t("Aviso-legal.s6-c")}</p>
      <p>{t("Aviso-legal.s6-d")}</p>
      <p>{t("Aviso-legal.s6-e")}</p>
      <br />
      <p>{t("Aviso-legal.s6-p2")}</p>
      <br />
      <h2>{t("Aviso-legal.s7-title")}</h2>
      <br />
      <p>{t("Aviso-legal.s7-p1")}</p>
      <br />
      <p>
        {t("Aviso-legal.s7-p2-before")}
        <Link to="/politica-privacidad">
          {t("Aviso-legal.s7-link")}
        </Link>
        {t("Aviso-legal.s7-p2-after")}
      </p>
      <br />
      <h2>{t("Aviso-legal.s8-title")}</h2>
      <br />
      <p>{t("Aviso-legal.s8-p1")}</p>
      <br />
      <p>{t("Aviso-legal.s8-p2")}</p>
      <br />
      <p>{t("Aviso-legal.s8-p3")}</p>
      <br />
      <p>{t("Aviso-legal.s8-p4")}</p>
      <br />
      <h2>{t("Aviso-legal.s9-title")}</h2>
      <br />
      <p>{t("Aviso-legal.s9-p1")}</p>
      <br />
      <p>{t("Aviso-legal.s9-p2")}</p>
      <br />
      <p>{t("Aviso-legal.s9-p3")}</p>
      <br />
      <h2>{t("Aviso-legal.s10-title")}</h2>
      <br />
      <p>{t("Aviso-legal.s10-p1")}</p>
      <br />
      <h2>{t("Aviso-legal.s11-title")}</h2>
      <br />
      <h3>{t("Aviso-legal.s11-1-title")}</h3>
      <p>{t("Aviso-legal.s11-1-p1")}</p>
      <br />
      <h3>{t("Aviso-legal.s11-2-title")}</h3>
      <p>{t("Aviso-legal.s11-2-p1")}</p>
      <br />
      <p>{t("Aviso-legal.s11-2-p2")}</p>
      <br />
      <p>{t("Aviso-legal.s11-2-p3")}</p>
      <br />
      <h3>{t("Aviso-legal.s11-3-title")}</h3>
      <p>{t("Aviso-legal.s11-3-p1")}</p>
      <ul>
        <li>{t("Aviso-legal.s11-3-phone")}</li>
        <li>{t("Aviso-legal.s11-3-email")}</li>
      </ul>
      <p>{t("Aviso-legal.s11-3-p2")}</p>
      <br />
      <h3>{t("Aviso-legal.s11-4-title")}</h3>
      <p>{t("Aviso-legal.s11-4-p1")}</p>
      <br />
      <p>{t("Aviso-legal.s11-4-p2")}</p>
      <br />
      <p>{t("Aviso-legal.s11-4-p3")}</p>
      <br />
      <p>{t("Aviso-legal.last-update")}</p>
      <br />
    </div>
  );
}

function AvisoLegalLegacy({ t }) {
  return (
    <div className="politicas">
      <h1>{t("Aviso-legal.legal-title1")}</h1>
      <p>{t("Aviso-legal.legal-text1")}</p>
      <br />
      <p>{t("Aviso-legal.legal-text2")}</p>
      <br />
      <h2>{t("Aviso-legal.legal-title2")}</h2> <br />
      <p>
        {t("Aviso-legal.legal-text3")}
        <br />
        {t("Aviso-legal.legal-text3")}
        <br />
        {t("Aviso-legal.legal-text4")}
        <br />
        {t("Aviso-legal.legal-text5")}
        <br />
        {t("Aviso-legal.legal-text6")}
      </p>
      <br />
      <h2>{t("Aviso-legal.legal-title3")}</h2> <br />
      <p>{t("Aviso-legal.legal-text7")}</p>
      <br />
      <h2>{t("Aviso-legal.legal-title4")}</h2>
      <br />
      <p>
        {t("Aviso-legal.legal-text8")}
        <Link to="/politica-cookies">
          {t("Footer.politica-cookies-url")}
        </Link>
        .
      </p>
      <br />
      <h2>{t("Aviso-legal.legal-title5")}</h2>
      <br />
      {t("Aviso-legal.legal-text9")}
       
      <br />
      <h2>{t("Aviso-legal.legal-title6")}</h2>
      <br />
      <p>
        {t("Aviso-legal.legal-text10")}
        <Link to="/politica-privacidad">
          {t("Footer.politica-privacidad-url")}
        </Link>
        .
      </p>{" "}
      <br />
      <h2>{t("Aviso-legal.legal-title7")}</h2>
      <br />
      <p>{t("Aviso-legal.legal-text11")}</p>
      <br />
      <h2>{t("Aviso-legal.legal-title8")}</h2> <br />
      <p>{t("Aviso-legal.legal-text12")}</p>
      <br />
      <h2>{t("Aviso-legal.legal-title9")}</h2>
      <br />
      <p>{t("Aviso-legal.legal-text13")}</p>
      <br />
      <h2>{t("Aviso-legal.legal-title10")}</h2>
      <br />
      <p>{t("Aviso-legal.legal-text14")}</p>
      <br />
    </div>
  );
}

export default function Aviso() {
  const [t, i18n] = useTranslation("global");
  const lang = i18n.language || "";
  const isLegacy = lang.startsWith("pt");

  return (
    <div>
      <div className="container">
        <Row>
          <Col lg={3} sm={24} xs={24} span={8}></Col>

          <Col lg={18} sm={24} xs={24}>
            <Link to="/">
              <img
                alt="Ecoscooting Delivery"
                src={Logo}
                style={{ width: "30%", marginBottom: "50px" }}
              />
            </Link>
            {isLegacy ? (
              <AvisoLegalLegacy t={t} />
            ) : (
              <AvisoLegalES t={t} />
            )}
          </Col>
          <Col lg={3} sm={24} xs={24} span={8}></Col>
        </Row>
      </div>
      <Footer />
    </div>
  );
}
